import React from 'react';
import { SEO } from './components/SEO';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0A0A0A] font-sans text-[#F5F0EB]" data-id="element-0">
      <SEO data-id="element-1" />
      <Navigation data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Services data-id="element-5" />
        <About data-id="element-6" />
        <Team data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Pricing data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}